export const webpage_apis = {
  InitialWebpageCustomizationDetails:
    "users/adminpanel/myaccount/webpage_sections",
};
